import { CloudRain, Cloud, Radar, Thermometer } from "lucide-react";
import { LEGENDS, type MeteoLayer } from "../lib/meteo-grid";

const options: Array<{ id: MeteoLayer; label: string; hint: string; icon: typeof Cloud }> = [
  { id: "radar", label: "Radar pioggia", hint: "Reale, ultime 2 ore", icon: Radar },
  { id: "rain", label: "Piovosità prevista", hint: "Ieri, oggi, domani", icon: CloudRain },
  { id: "clouds", label: "Nuvole", hint: "Masse in movimento", icon: Cloud },
  { id: "temperature", label: "Temperature", hint: "Falsi colori", icon: Thermometer }
];

export function MeteoPanel({ layer, onLayer }: { layer: MeteoLayer; onLayer: (layer: MeteoLayer) => void }) {
  const legend = LEGENDS[layer];
  return (
    <div className="meteo-panel">
      <span className="eyebrow">Meteo live</span>
      <h1>Com’è il tempo</h1>
      <p className="muted">Solo animazioni, senza luoghi né preferiti: scegli cosa guardare e segui come cambia ora per ora.</p>
      <div className="meteo-options" role="radiogroup" aria-label="Livello meteo">
        {options.map(({ id, label, hint, icon: Icon }) => (
          <button key={id} role="radio" aria-checked={layer === id} className={layer === id ? "is-active" : ""} onClick={() => onLayer(id)}>
            <Icon /><span><strong>{label}</strong><small>{hint}</small></span><i aria-hidden="true" />
          </button>
        ))}
      </div>
      <div className="meteo-legend">
        <strong>{legend.title}</strong>
        <div className="meteo-legend-bar" style={{ background: legend.gradient }} />
        <div className="meteo-legend-scale"><span>{legend.from}</span><span>{legend.to}</span></div>
        <p>{legend.note}</p>
      </div>
      <p className="muted meteo-sources">Fonti: Open-Meteo (previsioni), RainViewer (radar).</p>
    </div>
  );
}
